import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination-components"

export interface PagyPaginationProps {
  page: number
  pages: number
  onPageChange: (page: number) => void
}

export function PagyPagination({
  page,
  pages,
  onPageChange,
}: PagyPaginationProps) {
  if (pages <= 1) return null

  // Helper to generate page numbers with ellipsis if needed
  function getPageNumbers(current: number, total: number) {
    const delta = 2
    const range = []
    for (
      let i = Math.max(2, current - delta);
      i <= Math.min(total - 1, current + delta);
      i++
    ) {
      range.push(i)
    }
    if (current - delta > 2) range.unshift("...")
    if (current + delta < total - 1) range.push("...")
    range.unshift(1)
    if (total > 1) range.push(total)
    return range
  }

  const pageNumbers = getPageNumbers(page, pages)

  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            size="sm"
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1}
          />
        </PaginationItem>
        {pageNumbers.map((p, idx) => (
          <PaginationItem key={idx}>
            {p === "..." ? (
              <PaginationEllipsis />
            ) : (
              <PaginationLink
                onClick={() => onPageChange(Number(p))}
                isActive={p === page}
                size="sm"
              >
                {p}
              </PaginationLink>
            )}
          </PaginationItem>
        ))}
        <PaginationItem>
          <PaginationNext
            size="sm"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= pages}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
